import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import {
  contentListRequest,
  contentListSuccess,
  contentListFailure,
} from '../reducers/contentList';
import { authUserFailure } from '../reducers/login';
import { API_LINK } from '../../constants';
import {selectedProgram, selectedProgramId, selectedContentId, selectedContent, selectedVersionId, getSelectedThinktool} from '../selectors'
import { setExtensions } from '../reducers/userProgramsFull';

const API = `${API_LINK}api/user`;

function* contentListAxios() {
  const state = yield select(fullState => fullState);
  const { selectedProgramId, selectedModuleId } = state.userProgramsFullReducer;
  const {   user: { userId },
  token } = state.loginReducer;

  const response = yield call(() =>
    axios({
      method: 'get',
      url: `${API}/${userId}/contentMin?module_id=${selectedModuleId}`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${token}`,
      },
    }),
  );

  return response;
}

function* workerContentListSaga() {
  try {
    console.log('pepe9')
    const response = yield call(contentListAxios);
    console.log('pepe9', response)
    const responseFromcontentList = response.data;
   
    if(responseFromcontentList.data.components){
      console.log('pepe8',responseFromcontentList.data)
      yield put(contentListSuccess(responseFromcontentList.data.components[0].content));

      for (let index = 0; index < responseFromcontentList.data.components[0].content.length; index++) {
        const element = responseFromcontentList.data.components[0].content[index];
        if(element.type=='Assignments' || element.type=='WSR Assessments'){
          yield put(setExtensions(element.extensions_left))
        }
      }
    }else{
      console.log('pepe7',responseFromcontentList.data)
      yield put(contentListSuccess([]));

    }
    

    

    if (response.status === 500) {
      yield put(authUserFailure(response));
    }
  } catch (error) {
    console.log('pepe9',error)
    yield put(contentListFailure(error.response));
  }
}

export function* watcherContentListSaga() {
  yield takeLatest(contentListRequest().type, workerContentListSaga);
}
